import { combineReducers } from 'redux'
import  CommonReducer from './CommonReducer.js'

const rootReducer = combineReducers({
  CommonReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./public/reducers/index.js